import { useContext, useState, createContext } from "react";

const PatientDataContext = createContext();
const PatientDataUpdateContext = createContext();

export const usePatientData = () => {
  return useContext(PatientDataContext);
};

export const useUpdatePatientData = () => {
  return useContext(PatientDataUpdateContext);
};

export const PatientDataProvider = ({ children }) => {
  const [patientData, setPatientData] = useState(null);
  // console.log({ patientData });

  const updateUserData = (data) => {
    if (data) setPatientData((patientData) => ({ ...patientData, ...data }));
    else setPatientData(data);
  };

  return (
    <PatientDataContext.Provider value={patientData}>
      <PatientDataUpdateContext.Provider value={updateUserData}>
        {children}
      </PatientDataUpdateContext.Provider>
    </PatientDataContext.Provider>
  );
};
